import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-course-item',
    templateUrl: './course-item.component.html',
    imports: [CommonModule,],
    styleUrls: ['./course-item.component.css']
})
export class CourseItemComponent {
  @Input() color="red"

}
